import { ToolCallComplete } from "./anthropic-stream-handler.types";

// Role-specific content blocks
export type AssistantContentBlock =
  | { type: "text"; text: string }
  | {
      type: "tool_use";
      id: string;
      name: string;
      input: Record<string, unknown>;
    };

export type ToolContentBlock = {
  type: "tool_result";
  tool_use_id: string;
  content: string;
};

export type AIChatMessageDisplayState =
  | { kind: "hidden" }
  | { kind: "displaying"; visibleText: string }
  | { kind: "displayed" };

export interface BaseMessage {
  messageId?: string;
  displayState: AIChatMessageDisplayState;
}

export interface UserMessage extends BaseMessage {
  role: "user";
  content: string;
}

export interface AssistantMessage extends BaseMessage {
  role: "assistant";
  content: AssistantContentBlock[];
  toolCalls?: ToolCallComplete[];
}

export interface ToolResultMessage extends BaseMessage {
  role: "tool";
  content: ToolContentBlock[];
}

export type Message = UserMessage | AssistantMessage | ToolResultMessage;

export function isAssistantMessage(m: Message): m is AssistantMessage {
  return m.role === "assistant";
}

export function isToolResultMessage(m: Message): m is ToolResultMessage {
  return m.role === "tool";
}

export function isUserMessage(m: Message): m is UserMessage {
  return m.role === "user";
}

export const getAssistantMessageContent = (m: AssistantMessage): string => {
  if (m.displayState.kind === "displaying") {
    return m.displayState.visibleText;
  }
  return m.content.map((c) => (c.type === "text" ? c.text : "")).join("");
};
